import { Component } from '@angular/core';
import { ToolaSyncStatusComponent } from '../../toola-sync/toola-sync-status.component';

@Component({
  selector: 'app-admin-dashboard',
  imports: [ToolaSyncStatusComponent],
  templateUrl: './admin-dashboard.component.html',
  styleUrl: './admin-dashboard.component.scss'
})
export class AdminDashboardComponent {

}
